import * as React from 'react'
import { connect } from 'react-redux'
import { ApplicationState } from '../../store'
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import { Spinner, Container, Label, Input, Button,Progress } from 'reactstrap';
import { getSelectedOrganiser } from '../../store/organisers/selectors';
import { IOrganiserProfile } from '../../store/interface';
import queryString from 'query-string'
// @ts-ignore
import { store } from 'react-notifications-component';
import DetailForm from './detailForm';
import BlobUtil from '../../utils/blobUtil';

import { listRequest as listRequestAction,
    createRequest as createRequestAction,
    updateRequest as updateRequestAction,
    deleteRequest as deleteRequestAction,
    selectData as selectDataAction, 
    selectedData as selectedAction,
    selectedClear as selectedClearAction
} from '../../store/organisers/actions';
import OrganiserTopNav from '../../components/organiserTopNav';

// Separate state props + dispatch props to their own interfaces.
interface PropsFromState {
    route: any
    data: any
    ui : any
}

interface IState {
    isNew: boolean
    newId : string
    modalOverwriteWarning: boolean
    selectedFile: any
    uploadProgress:number
}

// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    listRequest : typeof listRequestAction
    createRequest : typeof createRequestAction
    updateRequest : typeof updateRequestAction
    deleteRequest : typeof deleteRequestAction
    selectData : typeof selectDataAction
    selectedData : typeof selectedAction
    selectedClear : typeof selectedClearAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch

class OrganiserDetailPage extends React.Component<AllProps, IState> {
    fileUploadProgressInterval:any;
    blobUtil = new BlobUtil();

    constructor(props: AllProps) {
        super(props);
        this.state = {
            modalOverwriteWarning : false,
            isNew : false,
            newId : '',
            selectedFile : undefined,
            uploadProgress: 0
        };
        this.readData = this.readData.bind(this);
        this.createOrUpdateData = this.createOrUpdateData.bind(this);
        this.deleteData = this.deleteData.bind(this);
        this.handleOverwriteWarning = this.handleOverwriteWarning.bind(this);
        this.uploadData = this.uploadData.bind(this);
    }

    public componentDidMount() {
        let id = this.props.route.match.params.id;
        if (id.toUpperCase() === "NEW"){
            this.setState({isNew: true, newId : this.generateId(6)});
        }else{
            this.props.selectData(id);
        }
    }
    public componentWillUnmount() {
        this.props.selectedClear();  
    } 

    generateId(length:number) {
        var result           = '';
        var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
           result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    readData(){
        const parsed = queryString.parse(this.props.route.location.search);
        var searchParams: any = {};
        searchParams["id"] = this.props.ui.selected;
        searchParams["offset"] = 0;
        searchParams["limit"] = 1;
        this.props.listRequest(searchParams);
    }

    componentDidUpdate(prevProps: AllProps) {
        //console.log("componentDidUpdate : " + this.props.ui.selected);
        // Load data if direct access from link
        if (prevProps.ui.selected === undefined && this.props.ui.selected != undefined && this.props.data === undefined){
            this.readData();
        }

        // Load data to state for chanages
        if ((this.props.ui.processState !== 3) && (
            (prevProps.data === undefined && this.props.data !== undefined) || 
            //(this.props.ui?.selected !== "")
            (prevProps.data?.id !== this.props.data?.id)
            )){

            this.props.selectedData();
        }
        // Show notification
        if ((prevProps.data?._etag != this.props.data?._etag) || 
            (prevProps.ui.processState != this.props.ui.processState) ){
            let notification = { show : false, title:"", type: "", message : "" };

            if (this.props.ui.processState === 1){ // Create/Update success
                if (this.state.isNew){ // Added successfully
                    this.setState({isNew: false});
                    this.props.route.history.push('/organisers/' + this.props.ui.selected );
                }
                notification.show = true;
                notification.type = "success";
                notification.message = "Save successfully";
                
            } else if (this.props.ui.processState === 2){ // Create/Update failed
                if (this.props.ui.isConflict){
                    this.setState({ modalOverwriteWarning : true});
                } else {
                    this.setState({ modalOverwriteWarning : false});

                    notification.show = true;
                    notification.type = "danger";
                    notification.message =  "Process failed. Error : \n" + this.props.ui.errors;
                }
            } else if (this.props.ui.processState === 3){ // Delete success
                // Show custom dialaog box
            } else if (this.props.ui.processState === 4){ // Delete failed
                notification.show = true;
                notification.type = "danger";
                notification.message =  "Delete failed. Error : \n" + this.props.ui.errors;
            }

            if (notification.show){
                store.addNotification({
                    title: notification?.title ?? "Info",
                    message: notification.message,
                    type: notification.type,
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 3000,
                        showIcon: true
                    }
                }); 
            }
        }
    }
    
    handleSelectValue = (selectedValue: any) => {
        let val: any = []
        if(selectedValue) {
            selectedValue.forEach((element:any) => {
                val.push(element.label);
            });
        }
        return val;
    }
   
    createOrUpdateData = async (formData:any) => {
       if (this.state.isNew){
            const n : IOrganiserProfile = {
                id : "",
                oId : "",             
                orgName : formData.orgName,
                orgProfile : formData.orgProfile,
                orgProfileImgURL : formData.orgProfileImgURL,
                orgEmail: formData.orgEmail,
                orgPhoneNo: formData.orgPhoneNo,
                orgAddress : formData.orgAddress,
                orgProfession : this.handleSelectValue(formData.orgProfession),
                contactPersonName : formData.contactPersonName,
                contactPersonTitle : formData.contactPersonTitle,
                contactPersonPhone : formData.contactPersonPhone,
                contactPersonWorkPhone : formData.contactPersonWorkPhone,
                contactPersonEmail : formData.contactPersonEmail,
                trainers : [],
                searchKeywords : formData.orgName.toLowerCase() + " " + formData.contactPersonName.toLowerCase()
            }
            this.props.createRequest(n);
        } else {
            let overwriteFlag = formData.Overwrite === "true"? true:false;
            this.props.updateRequest({
                id : this.props.ui.selected,
                oId : "",             
                orgName : formData.orgName,
                orgProfile : formData.orgProfile,
                orgProfileImgURL : formData.orgProfileImgURL,
                orgEmail: formData.orgEmail,
                orgPhoneNo: formData.orgPhoneNo,
                orgAddress : formData.orgAddress,
                orgProfession : this.handleSelectValue(formData.orgProfession),
                contactPersonName : formData.contactPersonName, 
                contactPersonTitle : formData.contactPersonTitle,
                contactPersonPhone : formData.contactPersonPhone,
                contactPersonWorkPhone : formData.contactPersonWorkPhone,
                contactPersonEmail : formData.contactPersonEmail,
                overwrite : overwriteFlag,
                searchKeywords : formData.orgName.toLowerCase() + " " + formData.contactPersonName.toLowerCase(),
                _etag : this.props.data._etag,
            });

            if (overwriteFlag === true){
                this.handleOverwriteWarning(); // Trigger close warning modal dialog
            }
        }
    }

    uploadData = async() => {
        this.blobUtil = new BlobUtil();
        this.startCheckProgress();
        let blobUrl = await this.blobUtil.UploadBlobToCointainer3(
            this.state.selectedFile.name,
            this.state.selectedFile,
            "images", "test"

        );
        this.stopCheckProgress();
        console.log("Blob URL : " + blobUrl);
    }

    startCheckProgress = () => {
        this.fileUploadProgressInterval = setInterval(() => {
          this.CheckProgress();
        }, 500);
    };
    
    CheckProgress = async () => {
        //console.log("===>" + this.blobUtil.getUploadProgress());
        this.setState({uploadProgress : this.blobUtil.getUploadProgress() });
    }

    stopCheckProgress = () => {
        clearInterval(this.fileUploadProgressInterval);
        this.setState({uploadProgress : 100 });
    }
    
    // On file select (from the pop up) 
    onFileChange = (event:any) => { 
        // Update the state 
        this.setState({ selectedFile: event.target.files[0] }); 
       
    }; 

    deleteData = async (doc:IOrganiserProfile) => {
        this.props.deleteRequest(doc);
    }
    
    handleOverwriteWarning(){
        this.setState({modalOverwriteWarning : !this.state.modalOverwriteWarning});
    }

    public render() {
        return (
            <div className="bg-light container">
                {this.props.ui.loading ? 
                    (
                        <div>Loading data&nbsp;<Spinner color="warning">Loading</Spinner></div>
                    )
                    :
                    (
                        <Container>
                            <OrganiserTopNav activeTab = "Organiser" organiserId ={this.props.data?.id} isNew = {this.state.isNew} />
                            <DetailForm 
                                props = {this.props} 
                                read = {this.readData}
                                save = {this.createOrUpdateData}
                                remove = {this.deleteData}
                                overwriteWarningFlag = {this.state.modalOverwriteWarning}
                                overwriteHandleWarning = {this.handleOverwriteWarning}
                                isNew = {this.state.isNew}
                                newId =  {this.state.newId}
                            />
                        </Container>
                    )
                }
                
            </div>
        )
    }
}

// It's usually good practice to only include one context at a time in a connected component.
// Although if necessary, you can always include multiple contexts. Just make sure to
// separate them from each other to prevent prop conflicts.
const mapStateToProps = (state: ApplicationState) => ({
    ui: state.organiser.ui,
    data: getSelectedOrganiser(state)
})

// mapDispatchToProps is especially useful for constraining our actions to the connected component.
// You can access these via `this.props`.
const mapDispatchToProps = {
    listRequest : listRequestAction,
    createRequest : createRequestAction,
    updateRequest : updateRequestAction,
    deleteRequest : deleteRequestAction,
    selectData : selectDataAction,
    selectedData : selectedAction,
    selectedClear : selectedClearAction
}

// Now let's connect our component!
// With redux v4's improved typings, we can finally omit generics here.
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrganiserDetailPage)
